import InvestmentCard from './InvestmentCard';

export default InvestmentCard;
